export const dismissOnboardingWizard = () => ({ type: 'DISMISS_ONBOARDING_WIZARD'})
export const showOnboardingWizard = () => ({ type: 'SHOW_ONBOARDING_WIZARD'})